<template>
  <HighlightContainerCheckout
    title="Em qual estado sua empresa deseja compensar o impacto ambiental de embalagens?"
    even
    class="pa-0"
  >
    <p class="text-body">
      Marque no mapa abaixo, ou busque no campo em branco, o estado brasileiro
      em que a sua empresa comercializa e deseja fazer a compensação ambiental
      de embalagens.
    </p>
    <v-container>
      <v-row class="state-selection-wrapper">
        <v-col cols="12" xl="5">
          <v-autocomplete
            :items="states"
            :ripple="false"
            item-text="name"
            item-value="id"
            no-data-text="Nenhum estado foi encontrado"
            label="Selecione o(s) estado(s)"
            hide-details="true"
            color="#26d07c"
            required
            solo
            multiple
          >
            <template #item="{ item }">
              <v-list-item
                style="cursor: pointer"
                class="d-flex"
                @click="toggleItem(item)"
              >
                <div>
                  <v-simple-checkbox
                    color="primary"
                    :ripple="false"
                    :value="isSelected(item)"
                    @click="toggleItem(item)"
                  />
                </div>
                <div class="ml-2">{{ item.name }}</div>
              </v-list-item>
            </template>
          </v-autocomplete>
          <div
            style="
              display: flex;
              flex-direction: row;
              width: 500px;
              flex-wrap: wrap;
            "
          >
            <div v-for="(state, i) in selectedStates" :key="i" class="badge">
              <p class="text-badge">{{ encurtaNome(state) }}</p>
              <v-img
                contain
                :src="images.close"
                alt="Close"
                style="width: 12px; height: 12px; cursor: pointer"
                @click="toggleItem(state)"
              ></v-img>
            </div>
          </div>
        </v-col>
        <v-col cols="12" xl="7">
          <Country
            :handle-select-state="toggleItem"
            :states-map="states"
            :hover-state-color="hoverStateColor"
            :apply-selected-state="true"
            :select-box-trigger="stateToSelectOnMap"
            :selected-states="selectedStates"
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-select
      v-model="coverageArea.regionSelected"
      :rules="coverageAreaRules.regionSelectedRules"
      validate-on-blur
      label="Escolha uma região..."
      :items="regions"
      item-text="title"
      solo
      return-object
      @change="onChangeRegion"
    />
    <v-select
      v-model="coverageArea.stateSelected"
      label="Distribuir na região escolhida"
      :items="coverageArea.regionSelected.states"
      item-text="title"
      :disabled="!coverageArea.regionSelected"
      solo
      return-object
      @change="onChangeState"
    />

    <v-select
      v-if="coverageArea.stateSelected.code === 'MS'"
      v-model="coverageArea.liability_year"
      label="Escolha o ano que deseja compensar"
      :items="liability_year_option"
      :disabled="coverageArea.stateSelected.code !== 'MS'"
      solo
      clearable
      required
      @change="onChangeLiabilityYear"
    /> -->
    <!--<v-select-->
    <!--v-if="containMS()"-->
    <!--v-model="coverageArea.liability_year"-->
    <!--label="Escolha o ano que deseja compensar"-->
    <!--:items="liability_year_option"-->
    <!--solo-->
    <!--clearable-->
    <!--required-->
    <!--@change="onChangeLiabilityYear"-->
    <!--/>-->

    <div v-if="showRJCheckbox" class="rjcheckbox">
      <v-checkbox
        class="pa-0 ma-0"
        :input-value="checkboxAware"
        :color="color"
        @change="setCheckboxAware"
      >
        <template v-slot:label>
          <div>
            Estou ciente que o prazo para
            <b>reporte individual compulsório</b> na plataforma do INEA (Órgão
            ambiental do RJ), cujo preenchimento é de
            <b>responsabilidade da empresa contratante</b>, encerrou no dia
            31/05/21.
          </div>
        </template>
      </v-checkbox>
    </div>
  </HighlightContainerCheckout>
</template>

<script>
import CheckoutProvider from '@/providers/CheckoutProvider';

export default {
  name: 'Step4',
  components: {
    HighlightContainerCheckout: () =>
      import('@/components/HighlightContainerCheckout.vue'),

    Country: () => import('@/components/Laws/Country.vue'),
  },
  data() {
    return {
      images: {
        close: require('@/assets/images/close-button.svg'),
      },
      coverageArea: {
        regionSelected: {
          value: 3,
          title: 'Sudeste',
          states: [
            { value: 31, region: 3, code: 'MG', title: 'Minas Gerais' },
            { value: 32, region: 3, code: 'ES', title: 'Espírito Santo' },
            { value: 33, region: 3, code: 'RJ', title: 'Rio de Janeiro' },
            { value: 35, region: 3, code: 'SP', title: 'São Paulo' },
          ],
        },
        stateSelected: { value: 35, region: 3, code: 'SP', title: 'São Paulo' },
        liability_year: '',
      },
      coverageAreaRules: {
        valid: true,
        regionSelectedRules: [
          v =>
            !!v || 'Selecione uma região para compensar seu impacto ambiental',
        ],
      },
      liability_year_option: [2019, 2020],
      regions: [
        {
          value: 1,
          title: 'Norte',
          states: [
            {
              value: 11,
              region: 1,
              code: 'RO',
              title: 'Rondônia',
            },
            {
              value: 12,
              region: 1,
              code: 'AC',
              title: 'Acre',
            },
            {
              value: 13,
              region: 1,
              code: 'AM',
              title: 'Amazonas',
            },
            {
              value: 14,
              region: 1,
              code: 'RR',
              title: 'Roraima',
            },
            {
              value: 15,
              region: 1,
              code: 'PA',
              title: 'Pará',
            },
            {
              value: 16,
              region: 1,
              code: 'AP',
              title: 'Amapá',
            },
            {
              value: 17,
              region: 1,
              code: 'TO',
              title: 'Tocantins',
            },
          ],
        },
        {
          value: 2,
          title: 'Nordeste',
          states: [
            {
              value: 21,
              region: 2,
              code: 'MA',
              title: 'Maranhão',
            },
            {
              value: 22,
              region: 2,
              code: 'PI',
              title: 'Piauí',
            },
            {
              value: 23,
              region: 2,
              code: 'CE',
              title: 'Ceará',
            },
            {
              value: 24,
              region: 2,
              code: 'RN',
              title: 'Rio Grande do Norte',
            },
            {
              value: 25,
              region: 2,
              code: 'PR',
              title: 'Paraíba',
            },
            {
              value: 26,
              region: 2,
              code: 'PE',
              title: 'Pernambuco',
            },
            {
              value: 27,
              region: 2,
              code: 'AL',
              title: 'Alagoas',
            },
            {
              value: 28,
              region: 2,
              code: 'PE',
              title: 'Sergipe',
            },
            {
              value: 29,
              region: 2,
              code: 'BA',
              title: 'Bahia',
            },
          ],
        },
        {
          value: 3,
          title: 'Sudeste',
          states: [
            {
              value: 31,
              region: 3,
              code: 'MG',
              title: 'Minas Gerais',
            },
            {
              value: 32,
              region: 3,
              code: 'ES',
              title: 'Espírito Santo',
            },
            {
              value: 33,
              region: 3,
              code: 'RJ',
              title: 'Rio de Janeiro',
            },
            {
              value: 35,
              region: 3,
              code: 'SP',
              title: 'São Paulo',
            },
          ],
        },
        {
          value: 4,
          title: 'Sul',
          states: [
            {
              value: 41,
              region: 4,
              code: 'PR',
              title: 'Paraná',
            },
            {
              value: 42,
              region: 4,
              code: 'SC',
              title: 'Santa Catarina',
            },
            {
              value: 43,
              region: 4,
              code: 'RS',
              title: 'Rio Grande do Sul',
            },
          ],
        },
        {
          value: 5,
          title: 'Centro-Oeste',
          states: [
            {
              value: 50,
              region: 5,
              code: 'MS',
              title: 'Mato Grosso do Sul',
            },
            {
              value: 51,
              region: 5,
              code: 'MT',
              title: 'Mato Grosso',
            },
            {
              value: 52,
              region: 5,
              code: 'GO',
              title: 'Goiás',
            },
            {
              value: 53,
              region: 5,
              code: 'DF',
              title: 'Distrito Federal',
            },
          ],
        },
      ],
      color: '#01ee55',
      selectedStates: [],
      states: [
        {
          id: 'BR-AM',
          name: 'Amazonas',
          color: '#CDCDD0',
          value: 13,
        },
        {
          id: 'BR-RO',
          name: 'Rondônia',
          color: '#CDCDD0',
          value: 11,
        },
        {
          id: 'BR-MT',
          name: 'Mato Grosso',
          color: '#CDCDD0',
          value: 51,
        },
        {
          id: 'BR-MA',
          name: 'Maranhão',
          color: '#CDCDD0',
          value: 21,
        },
        {
          id: 'BR-PI',
          name: 'Piauí',
          color: '#CDCDD0',
          value: 22,
        },
        {
          id: 'BR-RN',
          name: 'Rio Grande do Norte',
          color: '#CDCDD0',
          value: 24,
        },
        {
          id: 'BR-DF',
          name: 'Distrito Federal',
          color: '#CDCDD0',
          value: 53,
        },
        {
          id: 'BR-SP',
          name: 'São Paulo',
          color: '#CDCDD0',
          value: 35,
        },
        {
          id: 'BR-PR',
          name: 'Paraná',
          color: '#CDCDD0',
          value: 41,
        },
        {
          id: 'BR-SC',
          name: 'Santa Catarina',
          color: '#CDCDD0',
          value: 42,
        },
        {
          id: 'BR-RR',
          name: 'Roraima',
          color: '#CDCDD0',
          value: 14,
        },
        {
          id: 'BR-PA',
          name: 'Pará',
          color: '#CDCDD0',
          value: 15,
        },
        {
          id: 'BR-AP',
          name: 'Amapá',
          color: '#CDCDD0',
          value: 16,
        },
        {
          id: 'BR-AC',
          name: 'Acre',
          color: '#CDCDD0',
          value: 12,
        },
        {
          id: 'BR-GO',
          name: 'Goiás',
          color: '#CDCDD0',
          value: 52,
        },
        {
          id: 'BR-ES',
          name: 'Espírito Santo',
          color: '#CDCDD0',
          value: 32,
        },
        {
          id: 'BR-CE',
          name: 'Ceará',
          color: '#CDCDD0',
          value: 23,
        },
        {
          id: 'BR-PB',
          name: 'Paraíba',
          color: '#CDCDD0',
          value: 25,
        },
        {
          id: 'BR-SE',
          name: 'Sergipe',
          color: '#CDCDD0',
          value: 28,
        },
        {
          id: 'BR-TO',
          name: 'Tocantins',
          color: '#CDCDD0',
          value: 17,
        },
        {
          id: 'BR-RJ',
          name: 'Rio de Janeiro',
          color: '#CDCDD0',
          value: 33,
        },
        {
          id: 'BR-MS',
          name: 'Mato Grosso do Sul',
          color: '#CDCDD0',
          value: 50,
        },
        {
          id: 'BR-AL',
          name: 'Alagoas',
          color: '#CDCDD0',
          value: 27,
        },
        {
          id: 'BR-PE',
          name: 'Pernambuco',
          color: '#CDCDD0',
          value: 26,
        },
        {
          id: 'BR-BA',
          name: 'Bahia',
          color: '#CDCDD0',
          value: 29,
        },
        {
          id: 'BR-MG',
          name: 'Minas Gerais',
          color: '#CDCDD0',
          value: 31,
        },
        {
          id: 'BR-RS',
          name: 'Rio Grande do Sul',
          color: '#CDCDD0',
          value: 43,
        },
      ],
      hoverStateColor: '#26d07c',
      autocompleteStates: [],
      stateToSelectOnMap: [],
    };
  },
  computed: {
    // Checkbox do Rio de Janeiro
    showRJCheckbox() {
      return this.$store.getters.containRJ;
    },
    checkboxAware() {
      return this.$store.getters.checkboxAware;
    },
  },
  async beforeMount() {
    // await this.getStates();
    // console.log(this.states);
  },
  mounted() {
    this.coverageArea.regionSelected =
      this.$store.getters.regionCoverage.region.vmCount > 0
        ? this.$store.getters.regionCoverage.region
        : '';

    this.coverageArea.stateSelected =
      this.$store.getters.regionCoverage.state.vmCount > 0
        ? this.$store.getters.regionCoverage.state
        : '';

    // this.coverageArea.liability_year = this.$store.getters.regionCoverage.liability_year;

    this.checkClass();
  },
  methods: {
    postSelectedRegion(region) {
      this.$store.commit('changeRegion', region);
    },
    // Checkbox do Mato Grosso do Sul
    setCheckboxAware(value) {
      this.$store.commit('setCheckboxAware', value);
    },
    onChangeRegion() {
      this.$store.commit('changeRegion', this.coverageArea.regionSelected);
      this.coverageArea.stateSelected = {};
    },
    onChangeState() {
      this.$store.commit('changeState', this.coverageArea.stateSelected);

      this.coverageArea.liability_year = '';
    },
    onChangeLiabilityYear() {
      this.$store.commit('setLiabilityYear', this.coverageArea.liability_year);
    },
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#26d07c';
      }
    },
    async getStates() {
      try {
        this.$store.commit('setIsLoading', true);
        this.autocompleteStates = await CheckoutProvider.states().then(res => {
          this.states = res.data;
          return res.data;
        });
        this.$store.commit('setIsLoading', false);
      } catch (err) {
        console.error(err);
      }
    },
    isSelected(item) {
      // return this.selectedStates.find(state => state.id === item.id) != null;
      return this.selectedStates.includes(item);
    },
    containMS() {
      return this.$store.getters.containMS;
    },
    toggleItem(item) {
      if (this.selectedStates.find(state => state.id === item.id) != null) {
        this.selectedStates = this.selectedStates.filter(
          state => state.id !== item.id,
        );
      } else {
        this.selectedStates.push(item);
      }
      this.$store.commit('changeStates', this.selectedStates);
      if (this.$store.getters.containRJ) {
        this.$store.commit('setCheckboxAware', false);
      } else {
        this.$store.commit('setCheckboxAware', true);
      }
    },
    removeItem(item) {
      if (this.selectedStates.find(state => state.id === item.id) != null) {
        this.selectedStates = this.selectedStates.filter(
          state => state !== item,
        );
      }
    },
    encurtaNome(state) {
      return state.id.substring(3);
    },
    setSelectedState(state) {
      /*
        Ao selecionar um novo estado ou clicar em um estado já existente,
        é preciso enviar via props os estados selecionados(no select) para o componente do mapa via props.
        Da mesmo forma deve acontecer ao clicar no mapa, deve ser enviado de volta o que foi selecionado
        ou removido no mapa e ter a mesma ação no select.
      */
      if (typeof state === 'object') {
        this.selectedStates = [...state];
        this.stateToSelectOnMap = state;
      } else if (!this.selectedStates.includes(state)) {
        this.selectedStates.push(state);
      }
      // else if (this.selectedStates.includes(state)) {
      //   const idxToRemove =
      //     this.selectedStates.indexOf(state) !== undefined
      //       ? this.selectedStates.indexOf(state)
      //       : this.selectedStates.indexOf(state); // pegar index pelo valor
      //   // if (idxToRemove === undefined) {
      //   // }
      //   this.selectedStates.splice(state, idxToRemove);
      // }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.badge
  box-sizing: border-box
  display: flex
  flex-direction: row
  align-items: center
  padding-left: 16px
  width: 93px
  height: 40px
  background: #F2F2F3
  border: 2px solid #CDCDD0
  border-radius: 4px
  flex: none
  order: 0
  flex-grow: 0
  margin: 5px
  .text-badge
    width: 25px
    height: 24px
    font-style: normal
    font-weight: 400
    font-size: 16px
    line-height: 24px
    text-align: center
    color: #003036
    flex: none
    order: 0
    flex-grow: 0
    padding-top: 8px
.rjcheckbox
  .important
    color: #D40133
.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
</style>
